// types/date.types.ts
export type DateMode = 'date' | 'datetime';
export type DateRangeMode = 'single' | 'range';

// Base value structure
export interface DateValue {
    // For single mode
    date?: string;
    // For range mode
    startDate?: string;
    endDate?: string;
}

// Props interface without value conflict
export interface BaseDateInputProps {
    mode: DateRangeMode;
    type: DateMode;
    labels?: {
        single?: string;
        start?: string;
        end?: string;
    };
    disabled?: boolean;
    required?: boolean;
    minDate?: string;
    maxDate?: string;
    showTimeZone?: boolean;
    className?: string;
    // Validation
    validateRange?: boolean; // Ensure end date is after start date
}

// Separate interfaces for single and range modes
export interface SingleDateInputProps extends BaseDateInputProps {
    mode: 'single';
    value: string; // Just the date string for single mode
    onChange: (date: string) => void;
}

export interface RangeDateInputProps extends BaseDateInputProps {
    mode: 'range';
    value: { startDate?: string; endDate?: string };
    onChange: (range: { startDate?: string; endDate?: string }) => void;
}

// Union type for the main component
export type DateInputProps = SingleDateInputProps | RangeDateInputProps;

// Type guard for mode
export const isSingleMode = (props: DateInputProps): props is SingleDateInputProps => {
    return props.mode === 'single';
};